module.exports = __webpack_public_path__ + "img/3.eda715d0.png";